export default {
    data(){
        return {
            ElementPaths:{
                LandingPage:{
                    Button:['style.textColor', 'style.buttonColor'],
                    SocialMedia:['content.data'],
                    ButtonRow:['content.buttons'],
                    Divider: ['style.color'],
                    Testimonial:['content.quoteBox.style.backgroundColor', 'content.quoteBox.style.borderColor', 'content.authorBox.style.authorName.color','content.authorBox.style.jobTitle.color' ]
                },

                GraphicalEmail:{
                    Button: ['styles.color', 'styles.backgroundColor'],
                    Text:['values.value'],
                    Divider: ['styles.backgroundColor']
                },

                Collateral:{
                    Button:['textColor', 'buttonColor' ,'borderColor'],
                    Text: ['body'],
                    Shape: ['color1', 'color2', 'color3'],
                    Pagination: ['color']
                },

                Document:{
                    Button: ['style.textColor', 'style.buttonColor'],
                    Text: ['content.body'],
                    Divider: ['style.color'],
                    Quote: {
                        Header: ['headerStyles.backgroundColor', 'headerStyles.color'],
                        HeaderBorders: ['headerStyles.borderColor'],
                        PrimaryCells:['primaryRowStyles.backgroundColor', 'primaryRowStyles.color', 'primaryRowStyles.title.color','primaryRowStyles.description.color', 'primaryRowStyles.calculation.color' ],
                        SecondaryCells: ['secondaryRowStyles.backgroundColor', 'secondaryRowStyles.color', 'secondaryRowStyles.title.color','secondaryRowStyles.description.color', 'secondaryRowStyles.calculation.color'],
                        CellColumnBorders: ['cellBorderStyles.columnBordersColor'],
                        CellRowBorders: ['cellBorderStyles.rowBordersColor'],
                        Footer: ['footerStyles.backgroundColor','footerStyles.color'],
                        FooterBorders: ['footerStyles.borderColor'],
                    },

                    TextField: ['style.label.color', 'style.text.color'],
                    Signature:['style.label.color', 'style.text.color'],
                    Checkbox:['style.label.color', 'content.message'],
                    DateStamp:['style.label.color', 'style.text.color'],
                    RadioButton:['style.label.color', 'style.option.color']
                }
            }
        }
    },

    computed: {

        clientId() {
            return this.$store.state.context.client.id;
        },

        agencyId() {
            return this.$store.state.context.agency.id;
        },
        
        restUrl() {
            if (this.clientId) {
                return `/service/Brandings?$filter=ClientId eq ${ this.clientId }`;
            } else if (this.agencyId) {
                return `/service/Brandings?$filter=AgencyId eq ${ this.agencyId }`;
            }
        },
    },
    
    methods: {
        getBrandingConfiguration(type) {
            return new Promise((resolve, reject) => {
                if (this.restUrl) {
                    this.$api
                    .get(this.restUrl)
                        .then((response) => {
                            const branding = response.data.value.find((item) => item.Type === type);
                            resolve(JSON.parse(branding.Configuration));
                        })
                        .catch(() => {
                            reject('There was an error retrieving your branding options');
                        });
                    } else {
                        reject();
                    }
            });
        },
        
        hasLandingPageBranding(config) {
            if(!config){
                return false
            }
            
            const sections = config.sections;
            
            const elements = sections.flatMap((section) => {
                return section.columns.flatMap((column) => {
                    return column.elements.flatMap((element) => element);
                });
            });
            
            for (let i = 0; i < elements.length; i++) {
                if (this.findBrandInLandingPageElements(elements[i])) {
                    return true;
                }
            }
            
            for (let i = 0; i < sections.length; i++) {
                if (this.areBackgroundColorsEnableAndBranded((sections[i]).style)) {
                    return true;
                }
            }
            
            return false;
        },
        
        lookForBrandingInText(body) {
            const regex = /<[^>]*data-branding[^>]*>/;
            return regex.test(body);
        },
        
        findBrandInLandingPageElements(element) {
            const { LandingPage : { Button, SocialMedia, ButtonRow, Divider, Testimonial }} = this.ElementPaths;

            switch (element.type) {
                case 'text':
                    return this.lookForBrandingInText(element.content.body);
                case 'button':
                    return this.processNestedValues(Button, element, this.isColorBranded);
                case 'social-media':
                    return this.processNestedValues(SocialMedia, element, this.isSocialMediaBranded);
                case 'button-row':
                    return this.processNestedValues(ButtonRow, element, this.isButtonRowBranded);
                case 'divider':
                    return this.processNestedValues(Divider, element, this.isColorBranded); 
                case 'testimonial':
                    return this.processNestedValues(Testimonial, element, this.isColorEnabled);         
                default:
                    return false;
            }
        },

        isSocialMediaBranded(socialMedia){
            for(const network of socialMedia){
                if(network.isEnabled && this.isColorBranded(network.color)){
                    return true
                }
            }

            return false
        },

        isButtonRowBranded(row){
            const { LandingPage : { Button }} = this.ElementPaths;
            for (const button of row){
                if(this.processNestedValues(Button, button, this.isColorBranded)){
                    return true;
                }
            }

            return false;
        },

        hasBrandedType(obj) {
            if (typeof obj !== 'object' || obj === null) {
                return false;
            }
            
            if (obj.type === 'branded') {
                return true;
            }
    
            for (const key in obj) {
                if (key in obj && this.hasBrandedType(obj[key])) {
                    return true;
                }
            }
    
            return false;
        },

        hasCollateralBranding(configuration) {
            const { pages, masterPages } = configuration;
            
            function hasPageBranding(page) {
                if (this.isColorEnabled(page.backgroundColor)) {
                    return true;
                }
                return page.elements ? page.elements.some((element) => this.findBrandInCollateralElements(element)) : false;
            }
    
            function hasMasterPageBranding(masterPage) {
                if (this.isColorEnabled(masterPage.backgroundColor)) {
                    return true;
                }
                return masterPage.elements ? masterPage.elements.some((element) =>
                    this.findBrandInCollateralElements(element)
                ) : false;
            }
    
            for (const page of pages) {
                if (
                    hasPageBranding.call(this, page) ||
                    (page.masterPage && hasMasterPageBranding.call(this, page.masterPage))
                ) {
                    return true;
                }
            }

            if(masterPages) {
                for (const masterPage of masterPages) {
                    if (hasPageBranding.call(this, masterPage)) {
                        return true;
                    }
                }
            }
            
    
            return false;
        },

        
        
        findBrandInCollateralElements(element) {
            const { Collateral : { Button, Text, Pagination, Shape }} = this.ElementPaths;
            switch (element.type) {
                case 'text':
                    return this.processNestedValues(Text, element, this.lookForBrandingInText);
                case 'company-logo':
                    return true;
                case 'image':
                    return false;
                case 'shape':
                        return this.processNestedValues(Shape, element, this.lookForBrandingInShape);
                case 'button':
                    return this.processNestedValues(Button, element, this.isColorEnabled);
                case 'pagination':
                    return this.processNestedValues(Pagination, element, this.isColorBranded);
                default:
                    return false;
            }
        },
        
        lookForBrandingInShape(color) {
            if (!color.locked) {
                if (this.isColorEnabled(color)) {
                    return true;
                }
            }
            
            return false;
        },

        isColorEnabled(color) {
            if (color.enabled) {
                return this.isColorBranded(color);
            }
            return false;
        },


        isColorBranded(color) {
            if (color.type && color.type.toUpperCase() === 'BRANDED') {
                return true;
            }
            return false;
        },

        hasGraphicalEmailBranding(config) {
            if (!config || config.body) {
                return false;
            }
        
            const { sections, logo, footer } = config;

            if(logo && logo.type === 'image'){
                return true
            }

            if(footer && this.lookForBrandingInText(footer.value)){
                return true
            }
        
            function hasColumnBranding(column) {
                return column.elements.some((element) => this.findBrandInGraphicalEmailElements(element));
            }
        
            for (const section of sections) {
                if (this.isColorBranded(section.values.backgroundColor)) {
                    return true;
                }
        
                for (const column of section.columns) {
                    if (hasColumnBranding.call(this, column)) {
                        return true;
                    }
                }
            }
        
            return false;
        },
        
        findBrandInGraphicalEmailElements(element) {
            const { GraphicalEmail : {Button, Divider, Text}} = this.ElementPaths;

            switch(element.name){
                case 'button':        
                    return this.processNestedValues(Button, element, this.isColorBranded);
                case 'divider':
                    return this.processNestedValues(Divider, element, this.isColorBranded);
                case 'text':
                    return this.processNestedValues(Text, element, this.lookForBrandingInText);
                default:
                    return false
            }        
        },
        
        processNestedValues(paths, obj, callBack) {
            for (const path of paths) {
                const pathParts = path.split('.');
                let currentObj = obj;
        
                for (const part of pathParts) {
                    if (currentObj.hasOwnProperty(part)) {
                        currentObj = currentObj[part];
                    } else {
                        return; // Break out of the loop if a path part is not found
                    }
                }
        
                if (callBack(currentObj)) {
                    return true;
                }
            }
        
            return false;
        },

        hasDocumentBranding(config){
            if(!config){
                return false
            }

            const { pages } = config;

            function isTextEnableAndBranded(text, enabled){
                if(enabled && this.isColorBranded(text.color)){
                    return true
                } return false
            }

            function hasHeaderBranding(header){
                const {content: {hasLogo, hasDocumentName}, style } = header
                if (hasLogo || this.areBackgroundColorsEnableAndBranded(style) || isTextEnableAndBranded.call(this, (style.title, hasDocumentName))){
                    return true
                }

                return false
            }

            function hasFooterBranding(footer){
                const {content: {hasMessage, hasPageNumbering}, style } = footer;
                const {message, numbering} = style;

                if(hasMessage && this.isColorBranded(message.color)){
                    return true 
                }

                if(hasPageNumbering && this.isColorBranded(numbering.color)){
                    return true
                }

                if(this.areBackgroundColorsEnableAndBranded(style)){
                    return true
                }

                return false
            }

            function hasColumnBranding(column) {
                return column.elements.some((element) => this.findBrandInDocumentElements(element));
            }

            function hasFreeformPageElementsBranding(elements) {
                return elements.some((element) => this.findBrandInDocumentElements(element));
            }

            for (const page of pages){

                if(this.areBackgroundColorsEnableAndBranded(page.style)){
                    return true
                }
                
                if(page.pageType && page.pageType === 'freeform'){

                    if(hasFreeformPageElementsBranding.call(this, page.elements)){
                        return true;
                    }

                } else {

                const {header, footer, sections,  isIndividualHeaderVisible, isIndividualFooterVisible} = page;

                if (header){

                    if(isIndividualHeaderVisible && hasHeaderBranding.call(this, header)){
                        return true
                    }
                }

                if (footer){

                    if(isIndividualFooterVisible && hasFooterBranding.call(this, footer)){
                        return true
                    }
                }

                for( const section of sections){         
                    if(this.areBackgroundColorsEnableAndBranded(section.style)){
                        return true
                    }

                    for (const column of section.columns) {
                        if (hasColumnBranding.call(this, column)) {
                            return true;
                        }
                    }
                }
                                }
            }

            return false
        },

        areBackgroundColorsEnableAndBranded(style){
            if(style.hasSolidBackgroundColor && this.isColorBranded(style.backgroundColor)){
                return true
            }

            if(style.hasGradientBackground && (this.isColorBranded(style.gradientColor1) || this.isColorBranded(style.gradientColor2))){
                return true
            }

            return false
        },

        findBrandInDocumentElements(element){
            const { Document : { Button, Divider, Text, Quote }} = this.ElementPaths;

            switch(element.type){
                case 'logo':
                    return true;
                case 'text':
                    return this.processNestedValues(Text, element, this.lookForBrandingInText);
                case 'button':
                    return this.processNestedValues(Button, element, this.isColorBranded);
                case 'divider':
                    return this.processNestedValues(Divider, element, this.isColorBranded);
                case 'quote':
                    return this.hasQuoteBranding(Quote, element);
                case 'text-field':
                    return this.isFieldBranded(element);
                case 'signature':
                    return this.isFieldBranded(element);
                case 'checkbox':
                    return this.hasCheckboxBranding(element);
                case 'date-stamp':
                    return this.isFieldBranded(element);
                case 'radio-button':
                    return this.hasRadioButtonBranding(element);
                default:
                    return false
            }
        },

        isFieldBranded(field){
            const {content: {hasLabel}, style: {label, text}} = field;

            if((hasLabel && this.isColorBranded(label.color)) || this.isColorBranded(text.color)){
                return true
            }

            return false
        },

        hasRadioButtonBranding(field){
            const {content: {hasLabel}, style: {label, option}} = field;

            if((hasLabel && this.isColorBranded(label.color)) || this.isColorBranded(option.color)){
                return true
            }

            return false
        },

        hasQuoteBranding(quotePaths, quote){
            const { content: {hasHeaderRow, solutions}, style } = quote;
            const {headerStyles,  cellBorderStyles:{cellBorders}, footerStyles} = style;
            const {Header, HeaderBorders, CellColumnBorders, CellRowBorders, PrimaryCells, SecondaryCells, Footer, FooterBorders} = quotePaths;
            if(hasHeaderRow){
                if( this.processNestedValues(Header, style, this.isColorEnabled)){
                    return true
                }
            }

            if(headerStyles.borders.length){
                if(this.processNestedValues(HeaderBorders, style, this.isColorEnabled)){
                    return true
                }
            }

            if(cellBorders.includes('left') || cellBorders.includes('right')){
                if(this.processNestedValues(CellColumnBorders, style, this.isColorEnabled)){
                    return true
                }
            }

            if(cellBorders.includes('top') || cellBorders.includes('buttom')){
                if(this.processNestedValues(CellRowBorders, style, this.isColorEnabled)){
                    return true
                }
            }

            if(solutions.length > 0){
                if(this.processNestedValues(PrimaryCells, style, this.isColorEnabled)){
                    return true
                }
            }

            if(solutions.length > 1){
                if(this.processNestedValues(SecondaryCells, style, this.isColorEnabled)){
                    return true
                }
            }

            if(this.processNestedValues(Footer, style, this.isColorEnabled)){
                return true
            }

            if(footerStyles.borders.length){
                if(this.processNestedValues(FooterBorders, style, this.isColorEnabled)){
                    return true
                }
            }

            return false
        },

        hasCheckboxBranding(field){
            const {content: {hasLabel, message }, style: {label}} = field;

            if((hasLabel && this.isColorBranded(label.color)) || this.lookForBrandingInText(message)){
                return true
            }

            return false
        }
    },
};
